__turbopack_context__.v({
  "wrap": "sort-dropdown-module__qSKQRG__wrap",
});
